$(document).ready(function () {
  // header transition
  $(window).scroll(function () {
    var bodyOffsetTop = window.pageYOffset;
    var headerHeight = $(".header-head").height();

    if (bodyOffsetTop > headerHeight) {
      $(".site-header").addClass("show-logo");
    } else {
      $(".site-header").removeClass("show-logo");
    }
  });
  // header transition ends

  if (screen.width > 644) {
    $(".product_reviews").css("max-height", $(".product_reviews").height());
    $(".product_reviews").css(
      "height",
      "calc(100%-" + $(".product_title").height() + ")"
    );
  }

  $(".collection-list-slider").each(function () {
    var num_slides = $(this).data("slides");
    if ($(this).hasClass("for-slider-cleared") || $(this).hasClass("top-review-slider")) {
      var no_dots = false;
    } else {
      var no_dots = true;
    }
    if (num_slides >= 4) {
      var sm_num_slides = 3;
    } else {
      var sm_num_slides = 2;
    }
    $(this).slick({
      slidesToShow: num_slides,
      slidesToScroll: 1,
      autoplay: false,
      autoplaySpeed: 2000,
      arrows: true,
      adaptiveHeight: true,
      centerMode: true,
      centerPadding: "0px",
      nextArrow:
        '<div class="slick-custom-arrow slick-custom-arrow-right"><i class="fa fa-angle-right"></i></div>',
      prevArrow:
        '<div class="slick-custom-arrow slick-custom-arrow-left"><i class="fa fa-angle-left"></i></div>',
      infinite: true,
      dots: no_dots,
      responsive: [
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: sm_num_slides,
          },
        },
        {
          breakpoint: 768,
          settings: {
            slidesToShow: 2,
          },
        },
        {
          breakpoint: 480,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
          },
        },
        // You can unslick at a given breakpoint now by adding:
        // settings: "unslick"
        // instead of a settings object
      ],
    });
  });

  function mobileOnly() {
    $(".collection-slider-sp").slick({
      slidesToShow: 2,
      slidesToScroll: 1,
      autoplay: false,
      autoplaySpeed: 2000,
      arrows: true,
      infinite: true,
      adaptiveHeight: true,
      dots: true,
      responsive: [
        {
          breakpoint: 480,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
          },
        },
        // You can unslick at a given breakpoint now by adding:
        // settings: "unslick"
        // instead of a settings object
      ],
    });
    $(".notice-slider").slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      autoplay: false,
      autoplaySpeed: 2000,
      arrows: true,
      adaptiveHeight: true,
      infinite: true,
      dots: true,
      // You can unslick at a given breakpoint now by adding:
      // settings: "unslick"
      // instead of a settings object
    });
  }
  if (window.innerWidth < 768) {
    mobileOnly();
  }

  $(window).resize(function () {
    if (window.innerWidth < 768) {
      if (!$(".collection-slider-sp").hasClass("slick-initialized")) {
        mobileOnly();
      }
    } else {
      if ($(".collection-slider-sp").hasClass("slick-initialized")) {
        $(".collection-slider-sp").slick("unslick");
      }
    }
  });

  // Product Reviews For Top Page
  setTimeout(function(){ 

    // Get All The Reviews Details In a product_Review Array

    var custom_product_reviews = document.querySelectorAll('.custom-product-reviews-hidden');
    
    var product_reviews = [];
    
    custom_product_reviews.forEach(element =>{
      var p = {};
      
      p.id = element.querySelector('.product_id').childNodes[1].textContent;
      p.title = element.querySelector('.product_title').childNodes[1].textContent;
      p.handle = element.querySelector('.product_handle').childNodes[1].textContent;
      p.image = element.querySelector('.product_image').childNodes[1].getAttribute("src");

      var spr_review = element.querySelectorAll('.spr-review');


      p.ratings = [];
      p.reviews = [];
      p.reviewByOn = [];
      p.reviewTitle = [];
      
      spr_review.forEach(e => {
        var aria_label = e.querySelector('.spr-review-header').childNodes[1].getAttribute('aria-label');

        var review_rating = aria_label.split(' ')[0];
        p.ratings.push(review_rating);
        
        var review_text = e.querySelector('.spr-review-content').childNodes[1].textContent;
        p.reviews.push(review_text);

        var reviewTitle = e.querySelector('.spr-review-header-title').textContent;
        p.reviewTitle.push(reviewTitle);
        
        var reviewByOn = e.querySelector('.spr-review-header-byline').textContent;
        p.reviewByOn.push(reviewByOn);
      });
      
      product_reviews.push(p);
    });
    
    // Append All The Review To Html

    product_reviews.forEach(p => {
      if(p.ratings.length>0){
        
        var max = Math.max(...p.ratings);
        var  i = p.ratings.indexOf(""+max+"");
        
        var sliderContent = `<div class="custom-product-reviews p-2">
          <div class="row">
              <div class="col-12 col-md-12 product_title">
                  <h4><a href="/products/${p.handle}">${p.title}</a></h4>
              </div>
              <div class="col-12 col-md-6">
                  <div>
                      <a href="/products/${p.handle}">
                          <img class="lazyload" loading="lazy" src="${p.image}" alt="">
                      </a>
                  </div>
              </div>
              <div class="col-12 col-md-6">
                  <div class="top_review">
                         
                  <span class="spr-starratings spr-review-header-starratings" aria-label="4 of 5 stars" role="img">
                  <i class="spr-icon spr-icon-star"></i>
                  <i class="spr-icon ${2 <= p.ratings[i] ? 'spr-icon-star':' spr-icon-star-empty' }"></i>
                  <i class="spr-icon ${3 <= p.ratings[i] ? 'spr-icon-star':' spr-icon-star-empty' }"></i>
                  <i class="spr-icon ${4 <= p.ratings[i] ? 'spr-icon-star':' spr-icon-star-empty' }"></i>
                  <i class="spr-icon ${5 == p.ratings[i] ? 'spr-icon-star':' spr-icon-star-empty' }"></i>
                  </span>
                  <span style='font-size:20px;'>(${p.ratings.length})</span>
                  <h6>${p.reviewTitle[i]}</h6>
                  <h6>${p.reviewByOn[i]}</h6>
                  <div class="spr-review-content">
                    <p class="spr-review-content-body">
                        ${p.reviews[i]}
                    </p>
                  </div>

              </div>    
          </div>
        </div>`;

        $('.top-review-slider').append(sliderContent);
      }
    });

      $('.top-review-slider').slick({
        slidesToShow: 2,
        slidesToScroll: 1,
        autoplay: false,
        autoplaySpeed: 2000,
        arrows: true,
        adaptiveHeight: true,
        centerMode: true,
        centerPadding: "0px",
        nextArrow:
          '<div class="slick-custom-arrow slick-custom-arrow-right"><i class="fa fa-angle-right"></i></div>',
        prevArrow:
          '<div class="slick-custom-arrow slick-custom-arrow-left"><i class="fa fa-angle-left"></i></div>',
        infinite: true,
        dots: false,
        responsive: [
          {
            breakpoint: 1024,
            settings: {
              slidesToShow: 1,
            },
          },
          {
            breakpoint: 768,
            settings: {
              slidesToShow: 2,
            },
          },
          {
            breakpoint: 480,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1,
            },
          },
          // You can unslick at a given breakpoint now by adding:
          // settings: "unslick"
          // instead of a settings object
        ],
      });

  }, 3000);

  // Clear Session Storage Of Product Title
  var siteurl = window.location.href.toString().split("/");

  if(siteurl.indexOf('contact-us') == -1){ 
    sessionStorage.removeItem("title");
  }

});
